import React from 'react'
import { AuthContext } from 'context/authContext'
import { IDENTITY_SIGNIN_REDIRECT_DEFAULT_STATE_VALUES } from 'utils/constants'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './CleanStorage.scss'

export const CleanStorage = () => {
  const T_ROOT = 'cleanStorage.cleanStorage'
  const { authService } = React.useContext(AuthContext)
  const { t } = useTranslation()
  const location = useLocation()

  const { signinRedirect } = authService
  const [showMessage, setShowMessage] = React.useState(false)

  const cleanData = () => {
    localStorage.clear()
    sessionStorage.clear()
    setShowMessage(true)
    setTimeout(() => {
      setShowMessage(false)
    }, 3000)
  }

  const goToIdentity = () => {
    signinRedirect(location?.state ?? IDENTITY_SIGNIN_REDIRECT_DEFAULT_STATE_VALUES)
  }

  return (
    <div className={'clean-storage__container'}>
      {showMessage && (
        <div className={'clean-storage__message'}>
          <label>{t(`${T_ROOT}.label`) as string}</label>
        </div>
      )}
      <div className={'clean-storage__button'}>
        <button onClick={cleanData}>{t(`${T_ROOT}.cleanButton`) as string}</button>
        <button onClick={goToIdentity}>{t(`${T_ROOT}.loginButton`) as string}</button>
      </div>
    </div>
  )
}
